import React from 'react';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import { formatFullDate } from '../lib/timeFormat';

import styles from '../assets/css/booking.module.css';
import classNames from 'classnames';
import TimeOut from '../assets/img/timeOut.png';
import Header from '../common/Header';
import LoadingIndicator from '../common/LoadingIndicator';

import StepsIndicator from './StepsIndicator';
import Passenger from './steps/Passenger';
import Payment from './steps/Payment';
import Seats from './steps/Seats';
import Success from './steps/Success';

import Modal from '../Offers/Modal';
import useBookingState from './state';

import Footer from '../common/Footer';

const generateStep = ({ activeStep, ...props }) => {
  switch (activeStep) {
    case 'passenger':
      return <Passenger
        {...props}
      />;

    case 'payment':
      return <Payment
        {...props}
      />;

    case 'seats':
      return <Seats
        {...props}
      />;

    default:
      return <Passenger
        {...props}
      />;
  }
};

const Booking = () => {
  const navigate = useNavigate();
  const { id: bookingId } = useParams();
  const redirectToOffers = params => navigate('../offers', { state: params });

  const {
    state,
    state: { activeStep, steps, expired, booking },
    actions,
    actions: { toggleStep, goToSearch },
    meta,
    stats: { passengersStats = {} }
  } = useBookingState({ bookingId, redirectToOffers });

  const location = useLocation();
  const { source, params } = location.state || 'Unknown';

  const suggested_date = booking.date != undefined && formatFullDate(booking.date);
  const searched_for_date = params?.departureDate && formatFullDate(params.departureDate);
  if (activeStep === 'final') return <Success booking={booking} />;

  return (
    <>
      <header className={styles.booking_header}>
        <Header />

        <StepsIndicator
          toggleStep={toggleStep}
          goToSearch={goToSearch}
          activeStep={activeStep}
          steps={steps}
        />
        <LoadingIndicator loading={state.status === 'loading'} />
      </header>
      {state.status !== 'loading' &&
        <main className={styles.booking_Wrapper}>
          <section className={styles.booking_main}>
            {
              source == 'suggestions' &&
              <div className={classNames(styles.container, 'suggested-flights-title mini-icon')}>
                <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
                لا يوجد حجز متاح بالتاريخ المطلوب وهو <span className='highlight'>{searched_for_date}</span> وأقرب تاريخ متاح هو <span className='highlight'>{suggested_date}</span> تم تحديده بالفعل.
              </div>
            }
            {generateStep({
              booking,
              meta,
              goToSearch,
              ...state,
              ...actions,
            })}
          </section>

          <section className={styles.price_details}>
            {
              !!passengersStats?.adult?.count &&
              <div>
                <p> {passengersStats.adult.count || 1} x بالغ </p>
                <p>{passengersStats.adult.totalAmount.toLocaleString()}</p>
              </div>
            }
            {
              !!passengersStats?.child?.count &&
              <div>
                <p> {passengersStats.child.count} x طفل </p>
                <p>{passengersStats.child.totalAmount.toLocaleString()}</p>
              </div>
            }
            {
              !!passengersStats?.infant?.count &&
              <div>
                <p> {passengersStats.infant.count} x رضيع </p>
                <p>{passengersStats.infant.totalAmount.toLocaleString()}</p>
              </div>
            }

            {
              !!passengersStats?.holdBaggageTotal?.count &&
              <div>
                <p> {passengersStats.holdBaggageTotal.count} x حقيبة وزن </p>
                <p>{passengersStats.holdBaggageTotal.totalAmount.toLocaleString()}</p>
              </div>
            }
            {
              !!passengersStats?.carryOnBaggageTotal?.count &&
              <div>
                <p> {passengersStats.carryOnBaggageTotal.count} x حقيبة محمولة </p>
                <p>{passengersStats.carryOnBaggageTotal.totalAmount.toLocaleString()}</p>
              </div>
            }

            <div className={styles.booking_total}>
              <p>المجموع</p>
              <p>{passengersStats.bookingAmount.toLocaleString()} {state.booking.currency}</p>
            </div>
          </section>
        </main>
      }

      {
        expired && <Modal mode="tiny" onClose={goToSearch} content={
          <div>
            <div className='pop-up'>
              <div>
                <p className='pop-up-title'>لقد انتهت صلاحية هذا العرض</p>
                <p>سيتم إعادة توجيهك إلى  <Link to="../offers"> نتائج البحث </Link> </p>
              </div>
              <img src={TimeOut} width="100px" alt="timout" />
            </div>
          </div>
        } />

      }
      <Footer />
    </>
  );
};

export default Booking;